<template>
  <!-- 热搜榜单 -->
  <el-row>
    <div class="bannerImg"></div>
    <div class="lable">选择车系</div>
    <el-form ref="form" :model="carForm" label-width="80px">
      <el-form-item label-width="0">
        <el-select v-model="carForm.carId" placeholder="请选择车型" class="input">
          <el-option v-for="item in carTypes" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <el-row style="clear:both;min-height:20px;text-align:left">
    </el-row>
    <el-button type="primary" @click="genCarArticle">开始写作</el-button>

  </el-row>
</template>

<script>

// import Loading from '../components/js/Loading'
export default {
  name: 'index',
  data: function () {
    return {
      carTypes: [],
      models: [],
      carForm: {
        carId: '',
        tplId: '6'
      }

    }
  },

  methods: {
    genCarArticle () {
      let _this = this
      this.axios.postWithLoading('/webApi/carTempWrite/write', _this.carForm).then(resp => {
        this.$router.push({ path: '/newsEdit', query: { articleId: resp.data.autoNewsId, 'from': 'car' } })
      })
    }
  },
  components: {

  },
  watch: {

  },
  mounted () {
    let _this = this
    this.axios.get('/webApi/carType/listAll').then(resp => {
      _this.carTypes = resp.data.list
      _this.carForm.carId = resp.data.list[0].id
    })
  }
}
</script>
<style lang="less" scoped>
.bannerImg {
  background-image: url('../../assets/imgs/defindCarBanner.png');
}
</style>



// WEBPACK FOOTER //
// src/components/write/defindCar.vue